"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_REGISTRATION_FORM_CONFIG = exports.REGISTRATION_REGION_GROUP_LABELS = exports.REGISTRATION_REGION_GROUP_OPTION_LABELS = exports.REGISTRATION_AGE_GROUP_LABELS = exports.REGISTRATION_GENDER_LABELS = void 0;
exports.normalizeRegistrationFormConfig = normalizeRegistrationFormConfig;
const registration_enum_1 = require("../enums/registration.enum");
const marketing_const_1 = require("./marketing.const");
exports.REGISTRATION_GENDER_LABELS = {
    [registration_enum_1.RegistrationGender.MALE]: '남',
    [registration_enum_1.RegistrationGender.FEMALE]: '여',
};
exports.REGISTRATION_AGE_GROUP_LABELS = {
    [registration_enum_1.RegistrationAgeGroup.AGE_10_20]: '10~20대',
    [registration_enum_1.RegistrationAgeGroup.AGE_30_40]: '30~40대',
    [registration_enum_1.RegistrationAgeGroup.AGE_50_60]: '50~60대',
    [registration_enum_1.RegistrationAgeGroup.AGE_70_PLUS]: '70대 이상',
};
exports.REGISTRATION_REGION_GROUP_OPTION_LABELS = {
    [registration_enum_1.RegistrationRegionGroup.CAPITAL_AREA]: '서울/인천/수원/경기도',
    [registration_enum_1.RegistrationRegionGroup.CHUNGBUK_CHEONGJU]: '충북/청주',
    [registration_enum_1.RegistrationRegionGroup.CHUNGNAM_DAEJEON]: '충남/대전',
    [registration_enum_1.RegistrationRegionGroup.JEONBUK_JEONJU]: '전북/전주',
    [registration_enum_1.RegistrationRegionGroup.JEONNAM_GWANGJU]: '전남/광주',
    [registration_enum_1.RegistrationRegionGroup.GYEONGBUK_DAEGU]: '경북/대구',
    [registration_enum_1.RegistrationRegionGroup.GYEONGNAM_CHANGWON]: '경남/창원',
    [registration_enum_1.RegistrationRegionGroup.BUSAN]: '부산',
    [registration_enum_1.RegistrationRegionGroup.GANGWON]: '강원도/원주/춘천/강릉',
    [registration_enum_1.RegistrationRegionGroup.JEJU]: '제주도',
};
exports.REGISTRATION_REGION_GROUP_LABELS = {
    ...exports.REGISTRATION_REGION_GROUP_OPTION_LABELS,
    [registration_enum_1.RegistrationRegionGroup.CHUNGCHEONG]: '충청도/대전',
    [registration_enum_1.RegistrationRegionGroup.JEOLLA]: '전라도/광주',
    [registration_enum_1.RegistrationRegionGroup.GYEONGSANG]: '경상도/대구/부산/울산',
    [registration_enum_1.RegistrationRegionGroup.ETC_OVERSEAS]: '기타/해외',
};
exports.DEFAULT_REGISTRATION_FORM_CONFIG = {
    fields: {
        [registration_enum_1.RegistrationFormField.GENDER]: {
            enabled: true,
            required: true,
        },
        [registration_enum_1.RegistrationFormField.AGE_GROUP]: {
            enabled: true,
            required: true,
        },
        [registration_enum_1.RegistrationFormField.REGION_GROUP]: {
            enabled: true,
            required: true,
        },
        [registration_enum_1.RegistrationFormField.VISIT_MOTIVES]: {
            enabled: true,
            required: true,
            selectionMode: registration_enum_1.RegistrationVisitMotiveSelectionMode.MULTIPLE,
            options: marketing_const_1.PRE_REGISTRATION_AWARENESS_CHANNELS.map(channel => ({
                id: channel,
                label: marketing_const_1.AWARENESS_LABELS[channel],
                enabled: true,
                channel,
            })),
        },
    },
};
function normalizeRegistrationFormConfig(config) {
    const fields = (config?.fields ?? {});
    const visitMotives = (fields.visitMotives ??
        {});
    const options = normalizeVisitMotiveOptions(visitMotives);
    return {
        fields: {
            [registration_enum_1.RegistrationFormField.GENDER]: {
                ...exports.DEFAULT_REGISTRATION_FORM_CONFIG.fields.gender,
                ...fields.gender,
            },
            [registration_enum_1.RegistrationFormField.AGE_GROUP]: {
                ...exports.DEFAULT_REGISTRATION_FORM_CONFIG.fields.ageGroup,
                ...fields.ageGroup,
            },
            [registration_enum_1.RegistrationFormField.REGION_GROUP]: {
                ...exports.DEFAULT_REGISTRATION_FORM_CONFIG.fields.regionGroup,
                ...fields.regionGroup,
            },
            [registration_enum_1.RegistrationFormField.VISIT_MOTIVES]: {
                ...exports.DEFAULT_REGISTRATION_FORM_CONFIG.fields.visitMotives,
                ...visitMotives,
                options,
                channels: options
                    .map(option => option.channel)
                    .filter((channel) => Boolean(channel)),
            },
        },
    };
}
function normalizeVisitMotiveOptions(visitMotives) {
    if (visitMotives.options?.length) {
        return visitMotives.options
            .filter(option => option.id && option.label)
            .map(option => ({
            id: option.id,
            label: option.label,
            enabled: option.enabled ?? true,
            channel: option.channel,
        }));
    }
    const channels = visitMotives.channels?.length
        ? visitMotives.channels
        : marketing_const_1.PRE_REGISTRATION_AWARENESS_CHANNELS;
    return channels.map(channel => ({
        id: channel,
        label: marketing_const_1.AWARENESS_LABELS[channel],
        enabled: true,
        channel,
    }));
}
